import { OverlayTrigger, Popover } from "react-bootstrap";
import { CategoryIcon, DiscTemplate } from "./styled";


export function DisciplineObjectTooltip(props: any) {

    return (
        <>
            <DiscTemplate>
                <OverlayTrigger
                    placement={'top'}
                    overlay={
                        <Popover id={`popover-positioned-top`} style={{ width: '15%' }}>
                            <Popover.Body >
                                {props.node.project &&
                                    <p><b>Projeto:</b> {props.node.project}</p>
                                }
                                {props.node.type !== 'Discipline' &&
                                    <p><b>Disciplina:</b> {props.node.discipline_name}</p>
                                }
                                <p style={{ textAlign: 'left' }}>
                                    {props.node.type === 'Discipline' ? ('Objetos da disciplina') : (<></>)}
                                    {props.node.type === 'Item' ? ('Objetos da unidade') : (<></>)}
                                    {props.node.type === 'Theme' ? ('Objetos do tema') : (<></>)}
                                </p>
                                {!!props.node.media_category?.length && props.node.media_category?.map((category: any, index: any) => {
                                    return <CategoryIcon key={index} style={{ textAlign: 'left', color: '#6473FF' }} className={`material-icons-${category.icon}`}>{category.icon.split(' ')[1]}</CategoryIcon>
                                })}
                                {!!props.category?.length && props.category?.map((category: any, index: any) => {

                                    let result = props.node.media_category?.some((obj2: any) => {
                                        return category.category_icon === obj2.icon;
                                    })

                                    if (!result) {
                                        return <CategoryIcon key={index} style={{ textAlign: 'left' }} className={`material-icons-${category.category_icon}`}>{category.category_icon.split(' ')[1]}</CategoryIcon>
                                    }
                                })}
                            </Popover.Body>
                        </Popover>
                    }
                >
                    {props.children}
                </OverlayTrigger>
            </DiscTemplate>

        </>
    )
}